/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ChangeDetectorRef,
  Output,
  EventEmitter
} from '@angular/core';
import { Subject } from 'rxjs';
import { FittingSizeManagementService } from '../../sharedServices/fitting-size-management.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';


@Component({
  selector: 'app-generic-table',
  templateUrl: './generic-table.component.html',
  styleUrls: ['./generic-table.component.css']
})
export class GenericTableComponent implements OnInit {
  tableData;
  columnHeader;
  objectKeys = Object.keys;
  dataSource;
  selectedRow: Element;
  contextMenuPosition = { x: '0px', y: '0px' };
  @Input() selectedRowCopy;

  @Input() hasFilter = true;
  @Input() searchContent = true;
  @Input() hasRowDisabledFunctionality = true;
  @Input() sharedDataService;
  @Input() itemsPerPage = 100;
  @Input() resetTableSubject: Subject<boolean> = new Subject<boolean>();
  @Input() isAddedFittingSizesExpended;
  @Input() isExistingFittingSizesExtended;

  length = 100;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 100, 200, 250];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  @Output() contextMenuClick = new EventEmitter<{
    mouseEvent: MouseEvent;
    element: any;
  }>();
  @Output() clickRow = new EventEmitter<Element>();



  constructor(
    private readonly refreshService: ChangeDetectorRef,
    private readonly fittingSizeManagementService: FittingSizeManagementService) { }

  ngOnInit(): void {
    this.getData();
    this.resetTableSubject.subscribe(response => {
      /* istanbul ignore if */
      if (response) {
        this.getData();
      }
    });
  }

  getData() {
    this.columnHeader = this.sharedDataService.getTableHeader();

    this.sharedDataService.currentTableDataList.subscribe(data => {
      this.tableData = data;
      this.refresh();
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  getClass(): string {
    if (!this.isAddedFittingSizesExpended && !this.isExistingFittingSizesExtended) {
      return 'expand-table-content';
    }
    return 'fullscreen';
  }

  refresh() {
    this.dataSource = new MatTableDataSource(this.tableData);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    if (!this.refreshService[`destroyed`]) {
      this.refreshService.detectChanges();
    }
  }

  onClickRow(element: Element) {
    if (this.selectedRow === element) {
      return;
    }
    this.fittingSizeManagementService.setSelectedRowCopy(element);
    this.selectedRow = element;
    this.clickRow.emit(this.selectedRow);
  }

  onContextMenu(mouseEvent: MouseEvent, element: any) {
    mouseEvent.preventDefault();
    if (this.selectedRow !== element) {
      this.fittingSizeManagementService.setSelectedRowCopy(element);
      this.selectedRow = element;
      this.clickRow.emit(this.selectedRow);
    }
    this.contextMenuClick.emit({ mouseEvent, element });

  }

  hasContextMenu(row) {
    return row.isEnable || !this.hasRowDisabledFunctionality;
  }
}
